import { Navigate } from "react-router-dom";

export const getToken = () => {
  return window.localStorage.getItem("token");
};
export const getAuth = () => {
  try {
    return JSON.parse(window.localStorage.getItem("auth"));
  } catch (error) {
    return null;
  }
};

export const logout = () => {
  window.localStorage.clear();
  window.location.href = "/login";
};
